import React from "react";
import { List, Datagrid, TextField, NumberField } from "react-admin";

import { AvatarField } from "../../misc/customFields";

const MuscleImageList = props => {
  return (
    <List {...props}>
      <Datagrid>
        <NumberField source="image_id" label="Image ID" />
        <TextField source="name" />
        <AvatarField size={80} />
      </Datagrid>
    </List>
  );
};

export default MuscleImageList;
